module.exports = __webpack_public_path__ + "img/bigcommerce.40d73fa5.svg";